export enum TTradeProcessingState {
    TRANSFERRED = 'TRANSFERRED',
    OK = 'OK',
    QUEUED = 'QUEUED',
    TIMEOUT = 'TIMEOUT',
    FAILED = 'FAILED',
    PROCESSING = 'PROCESSING'
}